<app-loadable-content [loadingController]="locationsLoadingController" (onRetry)="loadInitialData()">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{ 'locations' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <table width="100%">
                <tr>
                    <td>
                        <app-data-table
                            [data]="locations"
                            [columns]="columns"
                            [toolbarActions]="locationToolbarModel.actions"
                            [compactToolbarActions]="locationToolbarModel.compactActions">
                        </app-data-table>
                    </td>
                </tr>
                <tr>
                    <td align="right">
                        <app-indeterminate-paginator [model]="paginatorModel" [pageSize]="10" [initialData]="initialPaginatorData"></app-indeterminate-paginator>
                    </td>
                </tr>
            </table>
        </mat-card-content>
    </mat-card>
</app-loadable-content>
